/*
  AULBERY — Bundle picker V2 (snippets/as-bundle-picker-v2.liquid)
  Moved 1:1 from the snippet's inline <script>. Values that used to be
  Liquid-interpolated are read from data-* attributes on the
  [data-as-bundle-v2] root.

  v2 of this file (445): the pack total now matches what checkout charges.

  It used to take the pack total and discount it in one go:
      Math.round(basePrice * qty * (1 - pct / 100))
  Shopify does not work that way. A Shopify automatic percentage discount
  is applied PER LINE ITEM, in cents, and the discount amount is FLOORED —
  so the customer pays the extra fraction of a cent, not the store. The
  line totals are then summed.

      $69.99 unit, 20% off:  6999 * 0.20 = 1399.8 -> 1399 off -> 5600 each
                             5600 * 2 = 11200 = $112.00
      $69.99 unit, 30% off:  6999 * 0.30 = 2099.7 -> 2099 off -> 4900 each
                             4900 * 3 = 14700 = $147.00

  The old maths gave $111.98 and $146.98 — one to three cents UNDER the
  real price, which is the wrong direction to be wrong in: the page
  promised a total the checkout would not honour. Both figures are now
  built from the per-unit price, so the bar, the "each" line, the price row
  and the button can only ever agree with the cart.

  If you change the tier percentages, nothing here needs touching — the
  rounding rule is Shopify's, not the tier's.
*/
(function () {
  if (window.ASBundleV2Booted) return;
  window.ASBundleV2Booted = true;

  // "{n}" style placeholders. A function replacement so "$" in money strings
  // is never read as a regex group reference.
  function fill(template, values) {
    return String(template).replace(/\{(\w+)\}/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
    });
  }

  function initBundleV2(root) {
    if (!root || root.dataset.asbV2Init === '1') return;
    root.dataset.asbV2Init = '1';

    var sectionId = root.dataset.section || '';
    var variants = JSON.parse(root.querySelector('[data-asb-variants]').textContent);
    var colorIdx = parseInt(root.dataset.colorIndex, 10);
    var sizeIdx = parseInt(root.dataset.sizeIndex, 10);
    var packs = JSON.parse(root.dataset.packs);
    var basePrice = parseInt(root.dataset.price, 10);
    var compareAt = parseInt(root.dataset.compareAt, 10) || 0;
    var moneyFormat = root.dataset.moneyFormat || '';
    var moneySymbol = root.dataset.moneySymbol || '$';
    var cartSections = root.dataset.cartSections || 'cart-drawer,cart-icon-bubble';
    var unit = root.dataset.unit || 'Item';
    var chipMode = root.dataset.chipMode || 'both';
    var roundSave = root.dataset.roundSave === '1';
    var badgeAlways = root.dataset.badgeAlways === '1';
    var eachLabel = root.dataset.eachLabel || 'each';
    var text = {
      single: root.dataset.singleName || '1 {unit}',
      packName: root.dataset.packName || '{n}-Pack',
      packSave: root.dataset.packSave || 'Save {pct}%',
      multiplier: root.dataset.multiplier || '×',
      empty: root.dataset.emptyText || '—',
      rowEach: root.dataset.rowEachLabel || 'each',
      rowSave: root.dataset.rowSavePrefix || 'Save',
      rowPct: root.dataset.rowPctSuffix || '% OFF',
      errColors: root.dataset.errPickColors || 'Pick {n} colors to continue.',
      errSize: root.dataset.errPickSize || 'Pick a size to continue.',
      errUnavailable: root.dataset.errUnavailable || '{color} is unavailable in size {size}.',
      errAdd: root.dataset.errAdd || 'Could not add to cart.',
      errNetwork: root.dataset.errNetwork || 'Could not add to cart. Try again.'
    };
    var formEl = document.getElementById(root.dataset.formId);

    var swatchEls = Array.prototype.slice.call(root.querySelectorAll('.asb-swatch'));
    var sizeEls = Array.prototype.slice.call(root.querySelectorAll('.asb-size'));
    var packsWrap = root.querySelector('[data-asb-packs]');
    var errEl = root.querySelector('[data-asb-error]');

    var colors = swatchEls.map(function (el) { return el.dataset.color; });
    var dispMap = {};
    swatchEls.forEach(function (el) { dispMap[el.dataset.color] = el.dataset.display || el.dataset.color; });

    var defaultPackNum = parseInt(root.dataset.defaultPack, 10) || 1;
    var packI = Math.min(defaultPackNum, packs.length) - 1;
    if (packI < 0) packI = 0;

    var order = [];
    var size = null;

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      if (moneyFormat.indexOf('amount') === -1) return moneySymbol + amount;
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toString())
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
    }

    // What ONE unit costs on this tier, the way Shopify works it out:
    // cents, per line, discount floored. Everything shown to the customer
    // is built from this, so no figure on the page can drift from the cart.
    function unitPriceFor(pct) {
      if (!pct) return basePrice;
      return basePrice - Math.floor((basePrice * pct) / 100);
    }

    function pack() { return packs[packI]; }
    function counts() {
      var c = {};
      order.forEach(function (col) { c[col] = (c[col] || 0) + 1; });
      return c;
    }
    function variantFor(color, sz) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.options[colorIdx] === color && v.options[sizeIdx] === sz) return v;
      }
      return null;
    }
    function colorHasStock(color) {
      return variants.some(function (v) { return v.options[colorIdx] === color && v.available; });
    }
    function sizeAvailable(sz) {
      var chosen = Object.keys(counts());
      if (!chosen.length) {
        return variants.some(function (v) { return v.options[sizeIdx] === sz && v.available; });
      }
      return chosen.every(function (color) {
        var v = variantFor(color, sz);
        return v && v.available;
      });
    }

    // ---------- pack buttons ----------
    packs.forEach(function (p, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'asb-pack';
      var name = p.qty === 1 ? fill(text.single, { unit: unit }) : fill(text.packName, { n: p.qty });
      var sub = p.qty === 1 ? money(basePrice) : fill(text.packSave, { pct: p.pct });
      btn.innerHTML = '<span class="asb-pack__name">' + name + '</span><span class="asb-pack__sub">' + sub + '</span>';
      btn.addEventListener('click', function () { setPack(i); });
      packsWrap.appendChild(btn);
    });
    var packEls = Array.prototype.slice.call(packsWrap.children);

    function setPack(i) {
      packI = i;
      var q = pack().qty;
      if (order.length > q) order = order.slice(order.length - q);
      while (order.length < q) order.push(nextFillColor());
      render();
    }
    function nextFillColor() {
      for (var i = 0; i < colors.length; i++) {
        if (colorHasStock(colors[i]) && order.indexOf(colors[i]) === -1) return colors[i];
      }
      if (order.length) return order[order.length - 1];
      for (var j = 0; j < colors.length; j++) if (colorHasStock(colors[j])) return colors[j];
      return colors[0];
    }

    // ---------- swatches ----------
    swatchEls.forEach(function (el) {
      el.addEventListener('click', function (e) {
        var color = el.dataset.color;
        if (!colorHasStock(color)) return;
        var badge = el.querySelector('[data-asb-badge]');
        if (badge && badge.contains(e.target) && el.classList.contains('is-selected')) {
          var idx = order.lastIndexOf(color);
          if (idx > -1 && order.length > 1) order.splice(idx, 1);
          render();
          return;
        }
        var q = pack().qty;
        if (order.length >= q) {
          var stole = false;
          for (var i = 0; i < order.length; i++) {
            if (order[i] !== color) { order.splice(i, 1); stole = true; break; }
          }
          if (!stole) return;
        }
        order.push(color);
        render();
      });
    });

    // ---------- sizes ----------
    sizeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        if (el.classList.contains('is-unavailable')) return;
        size = el.dataset.size;
        render();
      });
    });

    // ---------- render ----------
    function render() {
      var q = pack().qty;
      var c = counts();

      packEls.forEach(function (el, i) { el.classList.toggle('is-selected', i === packI); });

      var packLabelEl = root.querySelector('[data-asb-pack-label]');
      if (packLabelEl) {
        var nameEl = packEls[packI] ? packEls[packI].querySelector('.asb-pack__name') : null;
        packLabelEl.textContent = nameEl ? nameEl.textContent : '';
      }

      swatchEls.forEach(function (el) {
        var color = el.dataset.color;
        var n = c[color] || 0;
        el.classList.toggle('is-selected', n > 0);
        el.classList.toggle('is-soldout', !colorHasStock(color));
        var badge = el.querySelector('[data-asb-badge]');
        if (badge) {
          badge.textContent = n;
          // on a multi-pack every chosen colour carries its number, so
          // "1 on green, 2 on blue" reads as a 3-pack at a glance. On a
          // single unit a badge would just be noise.
          var show = n > 0 && (n > 1 || (badgeAlways && q > 1));
          badge.classList.toggle('is-shown', show);
        }
      });

      var hintEl = root.querySelector('[data-asb-hint]');
      if (hintEl) hintEl.style.display = q > 1 ? '' : 'none';

      var names = Object.keys(c);
      root.querySelector('[data-asb-color-label]').textContent = names
        .map(function (n) { var d = dispMap[n] || n; return c[n] > 1 ? d + ' ' + text.multiplier + c[n] : d; })
        .join(', ') || text.empty;

      sizeEls.forEach(function (el) {
        el.classList.toggle('is-selected', el.dataset.size === size);
        el.classList.toggle('is-unavailable', !sizeAvailable(el.dataset.size));
      });
      root.querySelector('[data-asb-size-label]').textContent = size || text.empty;

      // Per-unit first, then multiply — Shopify's order of operations.
      var unitNow = unitPriceFor(pack().pct);
      var total = unitNow * q;
      var struck = compareAt > basePrice ? compareAt * q : basePrice * q;

      // sync hidden variant id (single mode + keeps Dawn happy)
      if (formEl && names.length && size) {
        var v = variantFor(order[0], size);
        var input = formEl.querySelector('.product-variant-id');
        if (v && input) {
          input.value = v.id;
          input.disabled = !v.available;
        }
      }

      // ---------- price bar (V4 shape, pack figures) ----------
      var barNow = root.querySelector('[data-asb-bar-now]');
      var barWas = root.querySelector('[data-asb-bar-was]');
      var barSave = root.querySelector('[data-asb-bar-save]');
      var eachEl = root.querySelector('[data-asb-each]');
      var saveEls = root.querySelectorAll('[data-asb-save-el]');
      var saved = struck > total ? struck - total : 0;
      var pct = struck > 0 && saved > 0 ? Math.round((saved * 100) / struck) : 0;
      // free text after each figure. The space is added here so the
      // setting is typed as "OFF", not " OFF".
      var amtSuffix = root.dataset.amountSuffix ? ' ' + root.dataset.amountSuffix : '';
      var pctSuffix = root.dataset.pctSuffix ? ' ' + root.dataset.pctSuffix : '';

      if (barNow) barNow.textContent = money(total);
      if (barWas) {
        barWas.textContent = money(struck);
        barWas.style.display = saved > 0 ? '' : 'none';
      }
      if (barSave) {
        // the chip is derived from the two prices above it, so it can
        // never state a saving those prices do not support. Rounding
        // applies to the displayed saving only — the prices stay exact
        // and the percent is still worked out from the real figures.
        var savedCents = saved;
        if (roundSave) {
          var r = Math.round(saved / 100) * 100;
          // never round a real saving down to nothing
          savedCents = (r === 0 && saved > 0) ? saved : r;
        }
        var amtPart = money(savedCents) + amtSuffix;
        var pctPart = pct + '%' + pctSuffix;
        if (chipMode === 'amount') {
          barSave.textContent = amtPart;
        } else if (chipMode === 'percent') {
          barSave.textContent = pctPart;
        } else {
          // design F: amount, a faint rule, then the percent
          barSave.textContent = '';
          barSave.appendChild(document.createTextNode(amtPart));
          var rule = document.createElement('span');
          rule.className = 'asb-chip__rule';
          rule.setAttribute('aria-hidden', 'true');
          barSave.appendChild(rule);
          barSave.appendChild(document.createTextNode(pctPart));
        }
      }
      // no saving means neither the chip nor the "You save" label shows
      Array.prototype.forEach.call(saveEls, function (el) {
        el.classList.toggle('is-hidden', saved <= 0);
      });
      if (eachEl) {
        // the real per-unit price, not the total divided back down
        eachEl.textContent = q > 1 ? money(unitNow) + ' ' + eachLabel : '';
        eachEl.style.display = q > 1 ? '' : 'none';
      }

      // live price row (AU — Price row block)
      var priceRow = document.querySelector('#MainProduct-' + sectionId + ' [data-as-price-row]')
        || document.querySelector('[data-as-price-row]');
      if (priceRow) {
        var nowEl = priceRow.querySelector('[data-as-price-now]');
        var wasEl = priceRow.querySelector('[data-as-price-was]');
        var saveEl = priceRow.querySelector('[data-as-price-save]');
        var pctEl = priceRow.querySelector('[data-as-price-pct]');
        var rowEachEl = priceRow.querySelector('[data-as-price-each]');

        if (nowEl) nowEl.textContent = money(total);
        if (wasEl) {
          wasEl.textContent = money(struck);
          wasEl.style.display = saved > 0 ? '' : 'none';
        }
        if (saveEl) {
          var savePrefix = (saveEl.textContent.trim().split(' ')[0]) || text.rowSave;
          saveEl.textContent = savePrefix + ' ' + money(saved);
          saveEl.style.display = saved > 0 ? '' : 'none';
        }
        if (pctEl) {
          var rowPctSuffix = pctEl.textContent.replace(/^[0-9]+/, '') || text.rowPct;
          pctEl.textContent = pct + rowPctSuffix;
          pctEl.style.display = saved > 0 ? '' : 'none';
        }
        if (rowEachEl) {
          rowEachEl.textContent = q > 1 ? money(unitNow) + ' ' + text.rowEach : '';
          rowEachEl.style.display = q > 1 ? '' : 'none';
        }
      }

      // live price inside the ATC button
      var btnPrice = document.querySelector('#ProductSubmitButton-' + sectionId + ' .as-atc-price');
      var btnCompare = document.querySelector('#ProductSubmitButton-' + sectionId + ' .as-atc-compare');
      if (btnPrice) btnPrice.textContent = money(total);
      if (btnCompare) {
        if (struck > total) {
          btnCompare.textContent = money(struck);
          btnCompare.style.display = '';
        } else {
          btnCompare.style.display = 'none';
        }
      }
      hideError();

      // let the stock urgency panel re-read the selection
      document.dispatchEvent(new CustomEvent('variant:change'));
    }

    function showError(msg) {
      errEl.textContent = msg;
      errEl.classList.add('is-visible');
    }
    function hideError() {
      errEl.classList.remove('is-visible');
    }

    // ---------- submit interception for packs ----------
    function onSubmit(e) {
      if (!formEl || e.target !== formEl) return;
      if (pack().qty === 1) return; // Dawn native flow
      e.preventDefault();
      e.stopPropagation();
      bundleAdd();
    }
    document.addEventListener('submit', onSubmit, true);
    root.asbCleanup = function () {
      document.removeEventListener('submit', onSubmit, true);
    };

    function bundleAdd() {
      var q = pack().qty;
      if (order.length !== q) { showError(fill(text.errColors, { n: q })); return; }
      if (!size) { showError(text.errSize); return; }
      var c = counts();
      var items = [];
      var bad = null;
      Object.keys(c).forEach(function (color) {
        var v = variantFor(color, size);
        if (!v || !v.available) { bad = color; return; }
        items.push({ id: v.id, quantity: c[color] });
      });
      if (bad) { showError(fill(text.errUnavailable, { color: bad, size: size })); return; }

      var btn = document.getElementById('ProductSubmitButton-' + sectionId);
      var spinner = btn ? btn.querySelector('.loading__spinner') : null;
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      if (spinner) spinner.classList.remove('hidden');

      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: items,
          sections: cartSections,
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { showError(data.description || data.message || text.errAdd); return; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && data.sections && typeof drawer.renderContents === 'function') {
            // the line Dawn's product form runs before renderContents. The
            // drawer is rendered with is-empty when the cart is empty at
            // page load, and Dawn's CSS hides the header and collapses the
            // layout while that class is on. Without this the new cart is
            // painted into an empty-state shell.
            if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
            drawer.renderContents(data);
            // the step Dawn's product form takes after renderContents.
            // cart-drawer-items listens for this and re-fetches its own
            // list, which is what actually paints the items on a normal
            // add. Same event name, same source, same payload shape.
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
              var firstItem = data.items && data.items[0];
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: firstItem ? firstItem.variant_id : undefined,
                cartData: data
              });
            }
          } else {
            window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart';
          }
        })
        .catch(function () { showError(text.errNetwork); })
        .finally(function () {
          if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
          if (spinner) spinner.classList.add('hidden');
        });
    }

    // ---------- boot ----------
    setPack(packI);
    // default size: first available for the default color
    if (!size) {
      for (var i = 0; i < sizeEls.length; i++) {
        if (sizeAvailable(sizeEls[i].dataset.size)) { size = sizeEls[i].dataset.size; break; }
      }
    }
    render();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-as-bundle-v2]');
    for (var i = 0; i < roots.length; i++) initBundleV2(roots[i]);
  }
  function unloadAll(e) {
    var roots = document.querySelectorAll('[data-as-bundle-v2]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (e && e.target && e.target.contains && !e.target.contains(root)) continue;
      if (typeof root.asbCleanup === 'function') { root.asbCleanup(); root.asbCleanup = null; }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', unloadAll);
})();
